module.exports = __webpack_public_path__ + "static/media/galen_heuer.86b02489.png";